module.exports = __webpack_public_path__ + "videos/home-53-hero_9x16_cn.140b1fe.mp4";